import React from "react";

const Divider: React.FC = () => {
  return <div className="dropdown__divider" data-test="divider" />;
};

export default Divider;
